import * as auth from 'auth/constants'
import * as loginSignup from 'login-and-signup/constants'

const headerInitialState = {
    state: loginSignup.AUTH_CONTAINER_STATE_MAIN,
    isPasswordResetEmailSent: false,
    error: null,
}

export default function reducer(state = headerInitialState, action) {
    switch (action.type) {
        case loginSignup.SET_AUTH_CONTAINER_STATE:
            return {
                ...state,
                state: action.state,
                error: null,
            }

        case loginSignup.RESET_PASSWORD_SUCCESS:
            return {
                ...state,
                isPasswordResetEmailSent: true,
            }

        case loginSignup.SIGNUP_FLOW_ERROR:
            return {
                ...state,
                error: action.error,
            }

        case loginSignup.LOGIN_INITIATE:
        case loginSignup.SIGNUP_FLOW_INITIATE:
        case loginSignup.SEND_PASSWORD_RESET_EMAIL:
            return {
                ...state,
                error: null,
            }

        case auth.LOGOUT:
        case loginSignup.RESET_SIGNUP_FLOW_STATE:
            return headerInitialState
        default:
            return state
    }
}
